import React, {useState} from "react";
import {FormControlLabel, Slider, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";
import {makeStyles} from '@mui/styles';
import OrangeSwitch from "../../OrangeSwitch";

const useStyles = makeStyles((theme) => ({
    switchLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
}));

const ManualScoreEducation = ({updateScore, cvScore, noExperience}) => {

    const marks = [
        {
            value: 10,
            label: 'max 10',
        },
    ];

    const classes = useStyles();
    const [scores, setScores] = useState(cvScore);

    const handleSliderChange = (e) => {
        const {name, value} = e.target;
        setScores((prevScore) => ({
            ...prevScore,
            [name]: value,
        }));
        updateScore("experienceScore", {...scores, [name] : value})
    }

    const handleCheckChanged = (e) => {
        console.log(noExperience)
        const {name, checked} = e.target;
        setScores((prevScore) => ({
            ...prevScore,
            [name]: (checked),
        }));

        updateScore("experienceScore", {...scores, [name] : checked})
    }


    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Experience
                    </h3>
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        label="No evidence of job hopping"
                        checked={scores?.noJobHopping}
                        classes={{label:classes.switchLabel}}
                        data-testid={"jobHopping"}
                        name={"noJobHopping"}
                        onChange={(e) => {handleCheckChanged(e)}}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width:"100%", marginLeft:"0px"}}
                        label="Currently employed?"
                        name={"currentlyEmployed"}
                        checked={scores?.currentlyEmployed}
                        classes={{label:classes.switchLabel}}
                        data-testid={"currentlyEmployed"}
                        onChange={(e) => {handleCheckChanged(e)}}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Relevant job experience
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        max={10}
                        value={scores?.releventExperience}
                        valueLabelDisplay="auto"
                        data-testid={"relevantExp"}
                        name={"releventExperience"}
                        marks={marks}
                        onChange={(e) => {handleSliderChange(e)}}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Sufficient job experience
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        data-testid={"sufficientExp"}
                        value={scores?.sufficientExperience}
                        name={"sufficientExperience"}
                        max={10}
                        onChange={(e) => {handleSliderChange(e)}}
                        valueLabelDisplay="auto"
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Gramatically correct
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        value={scores?.grammar}
                        step={1}
                        name={"grammar"}
                        data-testid={"grammar"}
                        max={10}
                        onChange={(e) => {handleSliderChange(e)}}
                        valueLabelDisplay="auto"
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Relevant
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        name={"relevant"}
                        data-testid={"relevant"}
                        value={scores?.relevant}
                        step={1}
                        onChange={(e) => {handleSliderChange(e)}}
                        max={10}
                        valueLabelDisplay="auto"
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Work history matches skills
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        value={scores?.workHistory}
                        min={0}
                        step={1}
                        onChange={(e) => {handleSliderChange(e)}}
                        max={10}
                        data-testid={"workHistory"}
                        name={"workHistory"}
                        valueLabelDisplay="auto"
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={noExperience}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Average score for job
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        data-testid={"averageScore"}
                        value={scores?.averageScore}
                        step={1}
                        onChange={(e) => {handleSliderChange(e)}}
                        max={10}
                        name={"averageScore"}
                        valueLabelDisplay="auto"
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12} hidden={!noExperience}>
                    <div className={"text-4"}>
                        No work experience
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}
export default ManualScoreEducation;